
import $ from 'jquery';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Toasted from 'vue-toasted';
import { KanbanState } from '../kanban.model';
import { ListItem, WorkflowApproval, WorkflowApprovalCard } from '../../backend/backendapi';
import Spinner from '../../util/Spinner';
import { handleError } from '../../../api';
import { WindowType } from '../../../util';

declare var window: WindowType;

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'ApprovalRequestModal',
  components: {
    Spinner,
    vSelect,
  },
})
export default class ApprovalRequestModal extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;

  assignee: string | null = null;
  saving: boolean = false;

  get availableApprovers(): { id: string, name: string }[] {
    if (!this.state.selectedBoard) {
      return [];
    }

    const availableIds = this.state.selectedBoard.visibleToUsers?.filter(e => e !== window.application.user.id) ?? [];
    return availableIds.map(id => ({ id: id, name: (this.usersById.get(id)?.firstName ?? '') + ' ' + (this.usersById.get(id)?.lastName ?? '') }));
  }

  get canSave(): boolean {
    return !!this.assignee;
  }

  get usersById(): Map<string, ListItem> {
    return new Map(this.state.users.map(e => [e.id!, e]));
  }

  public open(): void {
    this.assignee = null;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  async save(): Promise<void> {
    this.saving = true;
    try {
      const cards = this.state.massSelectionCards.map(e => WorkflowApprovalCard.fromJS({ cardId: e.id }));
      const approval = WorkflowApproval.fromJS({ assignedTo: this.assignee, cards: cards });

      await this.state.approvalAPI.requestApproval(approval);
      this.$toasted.info(this.$t('kanban.approval.requestModal.requestCreated').toString());
      this.dismiss();
    } catch (e) {
      handleError(this.$toasted, this.$i18n, e);
    } finally {
      this.saving = false;
    }
  }
}
